/**
 * アクセスユーザの課金状態に関するjsonフィールドを表すクラス.
 */
export default class PaymentOutputData {
    constructor(data) {
        this.kindId = data.kindId;
        this.viewName = data.viewName;
        this.paymentAt = data.paymentAt;
    }
}